<template lang="">
	<div>
    <button @click="closeForm">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
    <ValidationObserver v-slot="{ invalid }">
      <v-card class="mt-8 mx-8">
        <div width="550" class="d-flex flex-column px-8 py-8">
          <div class="d-flex flex-column mr-8 mt-8">
            <ValidationProvider
                class="form-group"
                rules="required"
                v-slot="{ errors }"
              >
              <label class="font-weight-black">Nome</label>
              <input
                v-model="listEdit.group_name"
                type="text"
                class="inputCommunication mt-3"
                name='nome'
              >
              <span class="input-error">
                {{ errors[0] }} 
              </span>
           </ValidationProvider>
         </div>
          <div class="d-flex flex-column mr-8 mt-8">
            <label class="font-weight-black">ID Push Moe</label>
            <input
              v-model="listEdit.id_push_moe"
              type="text"
              class="inputCommunication mt-3"
            >
          </div>
          <div class="d-flex flex-row align-center mt-7 ">
            <label class="font-weight-black mr-4">Status</label>
            <v-switch
              v-model="listEdit.is_active"
              color="var(--blue)"
              inset
              class="mt-3 mr-10"
            ></v-switch>
          </div>
        </div>
      </v-card>
      <v-btn
        @click="onSubmit"
        class="mt-4 ml-8"
        height="62"
        width="95"
        color="var(--red)"
        :disabled="invalid"
      >
        Enviar
      </v-btn>
    </ValidationObserver>
	</div>
</template>
<script>
// Lib
import { mapActions, mapState, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import VueCookies from 'vue-cookies'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
	data () {
    return {
      openError: false,
      timeout: 3000,
      errorMessage: '',
      options: [
        {
          value: 'true',
          text: 'Ativo'
        },
        {
          value: 'false',
          text: 'Inativo'
        }
      ],
      textmessage: ''
    }
  },
  computed: {
    ...mapState('MessageForm', {
      smsList: 'items',
      listEdit: 'listToEdit'
    }),
    ...mapState('Communication', {
      item: 'communicationToEdit',
      loading: 'loading'
    }),
  },
  methods: {
    ...mapActions('MessageForm', [
      'getGroups',
      'postSmsList',
      'updateSmsList',
      'disableSmsList'
    ]),
    ...mapMutations('MessageForm', {
      unsetSmsListToEdit: 'UNSET_SMSLIST_TO_EDIT',
      setLoading: 'SET_LOADING'
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
    async onSubmit() {
      this.setLoading(true)
      const token = VueCookies.get('jwt-login')
      await this.smsListPost(token)
      await this.getGroups({
        page: 0,
        size: 700,
        token: token
      })
      this.setLoading(false)
      this.closeForm()
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    async smsListPost(token) {
      try {
        const response = await this.postSmsList([
          {
            group_name: this.listEdit.group_name,
            id_push_moe: this.listEdit.id_push_moe
          },
          token,
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Grupo cadastrado com sucesso',
            'var(--green)',
            this.unsetSmsListToEdit(),
            true
          )
          this.closeModal()
          this.unsetSmsListToEdit()
        }
      } catch (error) {
        this.openError = true
        this.errorMessage = error.message
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    closeForm() {
      this.unsetSmsListToEdit()
      this.$emit('close')
    },
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
  // .vs__select {
    .vs__dropdown-toggle {
      padding-top: 7px
    }
  // }

	.inputCommunication {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
    width: 475px !important;
    height: 48px;
    padding: 15px;
    background: transparent;
    font-family: var(--dm-sans-regular);
    color: var(--grey);
  }

  .v-overlay__scrim {
    height: 200%
  }

  .textareaEdit {
    width: 475px;
    border: 2px solid var(--grey-day-030);
  }
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/NewShippingForm.vue